export default "__VITE_ASSET__31435353__"